// extracted by mini-css-extract-plugin
module.exports = {"info":"AdminLinks-module_info_3kOat"};